import PropTypes from 'prop-types';
import React from 'react';

import { Container } from '@mui/material';
import Grid from '@mui/material/Grid';

import '@styles/PageView.scss';

function Actions({ children }) {
  return <>{children}</>;
}

function Ornaments({ children }) {
  return <>{children}</>;
}

function BreadcrumbsSlot({ children }) {
  return <>{children}</>;
}

function Content({ children, stylesTable = {} }) {
  return (
    <Grid size={{ xs: 12 }} style={stylesTable}>
      {children}
    </Grid>
  );
}

const PageView = ({
  title = '',
  description = '',
  actions = [],
  ornaments = null,
  stylesOrnaments = {},
  stylesTable = {},
  descriptionStyles = {},
  isForm = false,
  wide = false,
  children,
}) => {
  const childrenArray = React.Children.toArray(children);

  const actionsChild = childrenArray.find((child) => child?.type === Actions);
  const ornamentsChild = childrenArray.find((child) => child?.type === Ornaments);
  const breadcrumbsChild = childrenArray.find((child) => child?.type === BreadcrumbsSlot);
  const contentChild = childrenArray.find((child) => child?.type === Content);

  const resolvedActionsRaw = actionsChild ? React.Children.toArray(actionsChild.props.children) : actions;
  const resolvedActions = React.Children.toArray(
    Array.isArray(resolvedActionsRaw) ? resolvedActionsRaw : []
  );
  const resolvedOrnaments = ornamentsChild ? ornamentsChild.props.children : ornaments;
  const plainChildren = childrenArray.filter(
    (child) =>
      child?.type !== Actions &&
      child?.type !== Ornaments &&
      child?.type !== BreadcrumbsSlot &&
      child?.type !== Content
  );
  const resolvedContent = contentChild ? contentChild.props.children : plainChildren;

  const hasActions = Array.isArray(resolvedActions) && resolvedActions.length > 0;
  const hasOrnaments = !!resolvedOrnaments;

  return (
    <Container
      className="page-view"
      id="page-view"
      maxWidth={wide ? false : 'lg'}
      disableGutters={wide}
      sx={{
        ...(isForm ? {} : { minWidth: '0px' }),
        width: '100%',
        ...(wide && { px: { xs: 2, md: 3 } }),
      }}>
      <Grid container>
        {breadcrumbsChild && (
          <Grid size={{ xs: 12 }} className="page-breadcrumbs">
            {breadcrumbsChild.props.children}
          </Grid>
        )}
        <Grid size={{ xs: hasActions || hasOrnaments ? 8 : 12 }}>
          {title && (
            <div className={isForm && !description ? 'title-page title-page--form' : 'title-page'}>{title}</div>
          )}
        </Grid>
        {hasActions && (
          <Grid size={{ xs: 4 }} className="action">
            {resolvedActions.map((item) => (
              <React.Fragment key={item.key}>{item}</React.Fragment>
            ))}
          </Grid>
        )}

        {description && (
          <Grid size={{ xs: 12 }}>
            <div className="description-page" style={{ ...descriptionStyles }}>
              {description}
            </div>
          </Grid>
        )}

        {hasOrnaments && (
          <Grid className="ornament-adjusment" style={stylesOrnaments}>
            {resolvedOrnaments}
          </Grid>
        )}
        <Content stylesTable={stylesTable}>{resolvedContent}</Content>
      </Grid>
    </Container>
  );
};

PageView.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.node),
  ornaments: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  stylesOrnaments: PropTypes.object,
  stylesTable: PropTypes.object,
  descriptionStyles: PropTypes.object,
  isForm: PropTypes.bool,
  wide: PropTypes.bool,
};

Actions.propTypes = {
  children: PropTypes.node,
};

Ornaments.propTypes = {
  children: PropTypes.node,
};

BreadcrumbsSlot.propTypes = {
  children: PropTypes.node,
};

Content.propTypes = {
  children: PropTypes.node,
  stylesTable: PropTypes.object,
};

PageView.Actions = Actions;
PageView.Ornaments = Ornaments;
PageView.Breadcrumbs = BreadcrumbsSlot;
PageView.Content = Content;

export default PageView;
